import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowFilledDownIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 4,
	viewBox: "0 0 8 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 0L4 4L8 0H0Z",
		fill: "currentColor"
	})
});
export default SvgArrowFilledDownIcon;
